module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"webSiteDescription":"آسان‌ترین راه خرید بلیط، هتل و تور","downloadApplication":"دانلود اپلیکیشن از","downloadIosAndAndroid":"دانلود اپلیکیشن‌های اندروید و iOS"}}')
  delete Component.options._Ctor
}
